import { render, staticRenderFns } from "./FundReady.vue?vue&type=template&id=2f53371c&"
import script from "./FundReady.vue?vue&type=script&lang=js&"
export * from "./FundReady.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports